var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg flag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,5c-3.1,0-5.8-2-10.1-2a14.41,14.41,0,0,0-5,.9A4.87,4.87,0,0,0,6,2.7,3.08,3.08,0,0,0,3.2,0,3.05,3.05,0,0,0,0,3,3,3,0,0,0,1.5,5.6V31a.94.94,0,0,0,1,1h1a.94.94,0,0,0,1-1V25.8a17.2,17.2,0,0,1,8-1.8c3.1,0,5.8,2,10.1,2a14,14,0,0,0,8-2.5A3,3,0,0,0,32,21V6a3,3,0,0,0-4.2-2.8A17.23,17.23,0,0,1,21,5Zm8,16a11.57,11.57,0,0,1-6.4,2c-3.7,0-6.4-2-10.1-2a21.93,21.93,0,0,0-8,1.5V8a11.57,11.57,0,0,1,6.4-2C14.6,6,17.3,8,21,8a21.89,21.89,0,0,0,8-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0ac55b2984cd4ffee685f76b6ac9ea71.svg";
export { ForwardRef as ReactComponent };